import { makeStyles } from '@material-ui/styles';


const mtStyles = makeStyles(theme => ({
  pageActions: {
    margin: '1.5rem 0',
  },
  columnContainer: {
    'display': 'flex',
    'flex-direction': 'column',
    'flex-wrap' : 'wrap'
  },
  rowContainer: {
    'display': 'flex',
    'flex-direction': 'row',
    'flex-wrap' : 'wrap'
  },
  outlineButton: {
    border : '1.5px solid',
    '&:Hover': {
      border : '1.5px solid'
    }
  },
  link: {
    'cursor': 'pointer'
  },
  iconsRowContainer: {
    'display': 'flex',
    'flex-direction': 'row',
    'align-items' : 'center',
    'justify-content' : 'flex-start',
    flexWrap: 'nowrap',
    '& > svg': {
      marginRight: '10px',
    },
  },
  tableContainer: {
    overflowX: 'auto',
  },
  collapseCell: {
    width: theme.spacing(8),
  },
  channels: {
    padding: 0,
    border: 0,
    width: '100%'
  },
  noBorder: {
    padding: 0,
    border: 0,
  },
  pagination: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    marginTop: theme.spacing(3),
  },
  unstarred: {
    color: theme.palette.grey[300]
  },
  activeIcon: {
    color: '#673ab7',
  },
  disabledIcon: {
    color: theme.palette.grey[300],
  },
  chipSiteCount: {
    backgroundColor: theme.palette.grey[100]
  },
  problem: {
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
    [theme.breakpoints.down('md')]: {
      display: 'block',
    }
  }
}));


export default mtStyles;
